import { authHeader } from './auth-header';

// URI da API EasySaude
let baseApiUrl = process.env.VUE_APP_BASEURI + '/api/';

export const permissionService = {
    getAll,
    getRolesWithPermissions,
    updateRolePermissions,
    /** GET /api/permissions — lista global (id, name, description) para fallback da tela de perfis */
    listAll,
};

function getAll(empresaId) {
    const requestOptions = {
        method: 'GET',
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    };

    return fetch(baseApiUrl + `permissions/roles?empresa_id=${empresaId}`, requestOptions)
        .then(response => {
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    if (response.status === 401) {
                        // auto logout if 401 response returned from api
                        localStorage.removeItem('user');
                        localStorage.removeItem('currentEmpresa');
                        window.location.href = '/login';
                    }

                    const error = (data && data.message) || response.statusText;
                    return Promise.reject(error);
                }
                return data;
            });
        });
}

function listAll() {
    const requestOptions = {
        method: 'GET',
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    };

    return fetch(baseApiUrl + 'permissions', requestOptions)
        .then(response => {
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    if (response.status === 401) {
                        localStorage.removeItem('user');
                        localStorage.removeItem('currentEmpresa');
                        window.location.href = '/login';
                    }
                    const error = (data && data.message) || response.statusText;
                    return Promise.reject(error);
                }
                return data;
            });
        });
}

function getRolesWithPermissions(empresaId) {
    const requestOptions = {
        method: 'GET',
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    };

    return fetch(baseApiUrl + `permissions/roles?empresa_id=${empresaId}`, requestOptions)
        .then(response => {
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    if (response.status === 401) {
                        // auto logout if 401 response returned from api
                        localStorage.removeItem('user');
                        localStorage.removeItem('currentEmpresa');
                        window.location.href = '/login';
                    }

                    const error = (data && data.message) || response.statusText;
                    return Promise.reject(error);
                }
                return data;
            });
        });
}

function updateRolePermissions(roleId, permissions, empresaId) {
    const url = baseApiUrl + `permissions/role/${roleId}?empresa_id=${empresaId}`;
    const requestOptions = {
        method: 'PUT',
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({ permissions })
    };

    return fetch(url, requestOptions)
        .then(response => {
            // Verificar se a resposta está ok antes de tentar ler o texto
            if (!response.ok) {
                if (response.status === 401) {
                    // auto logout if 401 response returned from api
                    localStorage.removeItem('user');
                    localStorage.removeItem('currentEmpresa');
                    window.location.href = '/login';
                    return Promise.reject(new Error('Unauthorized'));
                }
                
                // Tentar ler mensagem de erro do servidor
                return response.text().then(text => {
                    try {
                        const data = text && JSON.parse(text);
                        const error = new Error(data && data.message ? data.message : response.statusText);
                        error.response = { status: response.status, data: data };
                        return Promise.reject(error);
                    } catch (e) {
                        const error = new Error(response.statusText || 'Erro ao atualizar permissões');
                        error.response = { status: response.status };
                        return Promise.reject(error);
                    }
                });
            }
            
            // Resposta ok, ler e parsear JSON
            return response.text().then(text => {
                try {
                    const data = text && JSON.parse(text);
                    return data;
                } catch (e) {
                    // Se não conseguir parsear, retornar texto como está
                    return { success: true, message: text || 'Permissões atualizadas com sucesso' };
                }
            });
        })
        .catch(error => {
            if (error.message === 'Failed to fetch' || error.name === 'TypeError') {
                const networkError = new Error('Erro de conexão. Verifique sua internet e tente novamente.');
                networkError.isNetworkError = true;
                return Promise.reject(networkError);
            }
            return Promise.reject(error);
        });
}
